import React from "react";
import {
  Card,
  CardContent,
  Box,
  Skeleton,
  useTheme,
} from "@mui/material";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";

const SkeletonTripCard = () => {
  const theme = useTheme();

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        overflow: "hidden",
      }}
    >
      <CardContent
        sx={{
          p: { xs: 2, sm: 3 },
          "&:last-child": { pb: { xs: 2, sm: 3 } },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: { xs: 2.5, sm: 3 },
          }}
        >
          {/* Відправлення */}
          <Box sx={{ flex: { sm: 1 }, minWidth: 0 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Skeleton variant="text" width={56} height={36} sx={{ flexShrink: 0 }} />
              <Skeleton variant="rounded" width={90} height={24} sx={{ borderRadius: 2 }} />
            </Box>
            <Skeleton variant="text" width={120} height={24} sx={{ mt: 1 }} />
            <Skeleton variant="text" width={160} height={20} />
          </Box>

          {/* Маршрут */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flex: { sm: "0 0 auto" },
              width: { xs: "100%", sm: 140 },
            }}
          >
            <Skeleton variant="rounded" width={64} height={24} sx={{ mb: 1, borderRadius: 2 }} />
            <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 0.5 }}>
              <Skeleton variant="rounded" height={2} sx={{ flex: 1, borderRadius: 1 }} />
              <DirectionsBusIcon sx={{ color: "action.disabled", fontSize: 28 }} />
              <Skeleton variant="rounded" height={2} sx={{ flex: 1, borderRadius: 1 }} />
            </Box>
          </Box>

          {/* Прибуття */}
          <Box sx={{ flex: { sm: 1 }, minWidth: 0 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Skeleton variant="text" width={56} height={36} sx={{ flexShrink: 0 }} />
              <Skeleton variant="rounded" width={90} height={24} sx={{ borderRadius: 2 }} />
            </Box>
            <Skeleton variant="text" width={120} height={24} sx={{ mt: 1 }} />
            <Skeleton variant="text" width={160} height={20} />
          </Box>

          {/* Ціна + кнопка */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "flex-start", sm: "flex-end" },
              minWidth: { sm: 140 },
            }}
          >
            <Skeleton variant="text" width={72} height={32} />
            <Skeleton variant="rounded" width={140} height={40} sx={{ mt: 1.5, borderRadius: 2 }} />
            <Skeleton variant="text" width={80} height={20} sx={{ mt: 1 }} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SkeletonTripCard;
